export default __webpack_public_path__ + "static/media/search.6410b0af.svg";